export function formatNumberCurrency(num) {
  const formattedNumber = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
  }).format(num);

  return formattedNumber;
}

export function formatToPhilippineTime(utcTimestamp) {
  const date = new Date(utcTimestamp);

  // Convert to Philippine Time (UTC+8)
  const options = {
    timeZone: "Asia/Manila",
    year: "2-digit",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const parts = formatter.formatToParts(date);

  const getPart = (type) => parts.find((p) => p.type === type)?.value;

  const day = getPart("day");
  const month = getPart("month");
  const year = getPart("year");
  const hour = getPart("hour").padStart(2, "0");
  const minute = getPart("minute");
  const dayPeriod = getPart("dayPeriod");

  return `${day}-${month}-${year} ${hour}:${minute} ${dayPeriod}`;
}

export function formatIsoToDDMMMYY(isoString) {
  if (!isoString) return;
  const date = new Date(isoString);

  const datePart = new Intl.DateTimeFormat("en-PH", {
    timeZone: "Asia/Manila",
    day: "2-digit",
    month: "short",
    year: "2-digit",
  }).format(date);

  const timePart = new Intl.DateTimeFormat("en-PH", {
    timeZone: "Asia/Manila",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  return `${datePart} /   ${timePart}`; // e.g., "25-Jun-25 09:36 AM"
}

// Return a modifid array of objects with no variance
export function getProductsWithVariance(snapshot) {
  return snapshot
    .filter((s) => s.variance !== 0) // keep only non-zero variances
    .map((s) => ({
      productId: s.productId,
      productName: s.productName,
      sellingPrice: s.sellingPrice,
      variance: s.variance,
      amount: s.amount,
    }));
}

export function mergeProductsAndQtySold(products, sold) {
  const soldMap = new Map(
    sold.map(({ product_name, qty_sold }) => [product_name, qty_sold])
  );

  // 4) Merge into your products array
  const merged = products.map((prod) => ({
    ...prod,
    qty_sold: soldMap.get(prod.products.product_name) ?? 0,
  }));

  return merged;
}

export function getTodayPHRange() {
  const now = new Date();

  // Get current time in Asia/Manila
  const formatter = new Intl.DateTimeFormat("en-PH", {
    timeZone: "Asia/Manila",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const parts = formatter.formatToParts(now);
  const year = parseInt(parts.find((p) => p.type === "year")?.value);
  const month = parseInt(parts.find((p) => p.type === "month")?.value) - 1; // zero-indexed
  const day = parseInt(parts.find((p) => p.type === "day")?.value);

  // Start and end of day in PH time (constructed as if in PH time)
  const startPH = new Date(Date.UTC(year, month, day, 0, 0, 0));
  const endPH = new Date(Date.UTC(year, month, day, 23, 59, 59, 999));

  // Subtract 8 hours to get UTC equivalents
  const startUTC = new Date(
    startPH.getTime() - 8 * 60 * 60 * 1000
  ).toISOString();
  const endUTC = new Date(endPH.getTime() - 8 * 60 * 60 * 1000).toISOString();

  return { startUTC, endUTC };
}

export function formatSacksFromKg(totalKg) {
  const sacks = Math.floor(totalKg / 25); // round down to whole sacks
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
  }).format(sacks);
}

export function getPhilippineDateRangeInUTC(phDateString) {
  let targetDate;

  // IF phDate is provided
  if (phDateString && /^\d{4}-\d{2}-\d{2}$/.test(phDateString)) {
    // Use selected date as Manila date
    targetDate = new Date(`${phDateString}T00:00:00+08:00`);
  } else {
    // Fallback to today's date in Asia/Manila
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Manila",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const formatted = formatter.format(now); // returns "YYYY-MM-DD"
    targetDate = new Date(`${formatted}T00:00:00+08:00`);
  }

  const startPH = new Date(targetDate);
  const endPH = new Date(targetDate);
  endPH.setHours(23, 59, 59, 999);

  return {
    startUTC: startPH.toISOString(),
    endUTC: endPH.toISOString(),
  };
}

export const generateQuickId = () =>
  `${Math.random().toString(36).slice(2, 8)}${Date.now()
    .toString(36)
    .slice(-4)}`;
